import React from 'react';

import { Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';

export const RegionShow: React.FC<ShowProps> = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField label="Country" source="country.name" />
    </SimpleShowLayout>
  </Show>
);
